import MessageQuote from './MessageQuote';

export default MessageQuote;
